export { default } from './Category';
export type { CategoryProps } from './types';
